import { Injectable, inject } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { Profile } from 'models/profile';
import { CreateProfileRequestV1, ProfilesService } from '../swagger-api-v1';
import { ChildProfileType } from '../../features/profiles/profile-management/create-profile-dialog/create-profile-dialog.component';
import { SnackBarService } from './snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  private profileService = inject(ProfilesService);
  private toast = inject(SnackBarService);

  public getProfile$(id: number): Observable<Profile> {
    return this.profileService.getProfileUsingGET(id).pipe(map((dto) => Profile.fromDTO(dto)));
  }

  public getProfiles$(): Observable<Profile[]> {
    return this.profileService
      .getProfilesUsingGET()
      .pipe(map((result) => result.profiles.map((profileDTO) => Profile.fromDTO(profileDTO))));
  }

  public deleteProfile$(profileId: number): Observable<void> {
    return this.profileService.deleteProfileUsingDELETE(profileId);
  }

  public createProfile$(
    name: string,
    childProfile: boolean,
    childProfileType?: ChildProfileType
  ): Observable<Profile> {
    const profileType = childProfile ? childProfileType : CreateProfileRequestV1.TypeEnum.STANDARD;
    const createProfileDTOV1: CreateProfileRequestV1 = { name: name.trim(), type: profileType };

    return this.profileService.createProfileUsingPOST(createProfileDTOV1).pipe(
      map((dto) => Profile.fromDTO(dto)),
      catchError(() => {
        this.toast.pop('GENERIC.ERROR');
        return of(undefined);
      })
    );
  }

  public updateProfile$(profile: Profile): Observable<Profile> {
    return this.profileService
      .updateProfileUsingPATCH(profile.id, profile.toDTO())
      .pipe(map((dto) => Profile.fromDTO(dto)));
  }
}
